<div class="smart-background">
  <div class="container casestudies-body">
    <div class="row">
      <div class="col-md-5 image-order">
        <img
          src="../../../../assets/industry/casestudies/integration-computerHealthcare.png"
          class="img-fluid smart-computer" alt="Smart integration engine"
        />
      </div>

      <div class="col-md-7 py-5">
        <p class="text-white link-casestudy"><span (click)="nav('/')">Home</span> / <span (click)="nav('/kalpita-case-studies/case-study')">Case Studies</span></p>
        <h1 class="py-2 smart-heading">
          Smart integration engine to centralize workflow with a secure
          corporate network to streamline communications
        </h1>
        <p class="py-3 smart-para">
          The client is a top tier technology service provider in the healthcare
          industry focused on bridging critical gaps in communication making
          healthcare accessible, affordable and quality-oriented. Essentially
          providing advisory consulting services, custom application
          development, and data solutions.
        </p>
        <div class="service-industry py-3">
          <div class="industry-box">
            <h6>Industry:<span class="healthcare">Healthcare</span></h6>
          </div>
          <div class="service-box">
            <h6>Service:<span>IT Consulting</span></h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- ARC Integration....................................................................... -->
<div class="arc-intbackground">
  <div class="container py-5">
    <div class="row">
      <h4 class="heading-arc py-4">ARC Integration</h4>
      <div class="col-md-6">
        <h5 class="heading-arc py-4">The challenge</h5>
        <p class ="portal">
          The client had an inefficient system for managing internal resources.
          There were about 18 internal applications, and 14 third-party applications
          (outside corporate network) consuming REST APIs hosted on AWS.
        </p>

        <h5 class="heading-arc py-4">The Objective</h5>
        <p class ="portal">
          A centralized integration engine meant an healthcare integration
          platform that supports the operations of the organization.
        </p>
        <ul>
          <li class="ico-img">
            Modernize the healthcare system by assisting with anything from
            interfaces to workflow to operational choices.
          </li>
          <li class="ico-img">No core processes</li>
          <li class="ico-img">Plug and play (any system can be source and destination)</li>
          <li class="ico-img">
            Any system could be onboarded and offboarded with respect to
            information exchange and processing with ease.
          </li>
        </ul>
      </div>

      <div class="col-md-6">
        <div class="bg-white ps-5 py-3">
          <h5 class="heading-arc py-4">The Result</h5>
          <p class ="portal">
            ARC would serve primarily as an integration engine, assisting in the
            implementation of the following features:
          </p>
          <ul>
            <li class="ico-img">
              Serve as an interface/channel for data exchange between systems.
            </li>
            <li class="ico-img">Set up single sign-on across several systems.</li>
          </ul>
        </div>

        <div class="ps-5">
          <h5 class="heading-arc py-4">Our Approach and Value add?</h5>
          <p class ="portal">
            We built the data integration engine for ARC. With integration to tools/ apps for data exchange,
            Kalpita would provide Consulting services to Emids on
            Architectural and Solution review and resource support on T&M for Project execution.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ARC New Portal.......................................................................... -->
<div class="container py-5">
  <div class="row">
    <h4 class="heading-arc py-4">ARC New Portal</h4>
    <div class="col-md-6">
      <h5 class="heading-arc py-4">The Objective</h5>
      <p class ="portal">Once the Integration Engine is stabilized, there is a need to build an ARC
        Intranet portal with Single
        Sign on using Office 365 Azure AD Authentication. </p>
        <h5 class="heading-arc py-4">Our Approach and Value add?</h5>
        <p class ="portal">Kalpita’s engineers designed and developed application using cutting edge technologies and agile
          methodologies, thereby involving customer in all critical stages of the development lifecycle.
        </p>
        <p class ="portal">Our QA team also perform validation on the developed features and use cases to ensure high quality of the deliverables.  </p>
        <h5 class="heading-arc py-4">Technologies used</h5>
        <!-- webapp row.................................................... -->
          <div class="row py-4">
            <div class="col-4">
                <p class="bold-head"><strong>Web App</strong></p>
            </div>
            <div class="col-4">
              <img src="../../../../assets/resources/casestudies/icons/angular-tech.png" class="img-fluid tech-icon" alt="technicalone"/>
            </div>
            <div class="col-2">
              <img src="../../../../assets/resources/casestudies/icons/html-tech.png" class="img-fluid tech-icon" alt="technicaltwo"/>
            </div>
            <div class="col-2">
              <img src="../../../../assets/resources/casestudies/icons/css-tech.png" class="img-fluid tech-icon" alt="technicalthree"/>
            </div>
          </div>
           <!-- API implementation row.................................................... -->
           <div class="row py-4">
            <div class="col-4">
                <p class="bold-head"><strong>API implementation</strong></p>
            </div>
            <div class="col-4">
              <img src="../../../../assets/resources/casestudies/icons/aspdot-net.png" class="img-fluid tech-icon" alt="technicalfour"/>
            </div>
          </div>
          <!-- Hosting row.................................................... -->
          <div class="row py-4">
            <div class="col-4">
                <p class="bold-head"><strong>Hosting  </strong></p>
            </div>
            <div class="col-4">
              <img src="../../../../assets/resources/casestudies/icons/azure-tech.png" class="img-fluid tech-icon" alt="technicalfive"/>
            </div>
          </div>

    </div>
    <div class="col-md-6">
      <img src="../../../../assets/resources/casestudies/solutions/arc-smartsolution.webp" alt="smart-solution" width="100%" >
    </div>
  </div>
</div>



